<template>
  <div :style="[ { height: '44px' }, themeCssVars ]" :class="['nav-bar',title.length > 0 ? 'nav-bar-padding' :'']">
        <svg-icon v-if="showBack" :style="{width: '30px',height: '30px'}" icon-class="nav_back" class-name="back-icon" @click.native="backClick" />
        <div class="title" :style="{ fontSize: '20px',lineHeight: '44px'}"> {{ title }} </div>
    </div>
  </template>
<script>

import {
  onWebPageBack
} from '@/utils/call-native'
import ThemeStyle from '@/mixin/theme-style'

const firstPageFromNativeKey = 'firstPageFromNativeKey'

export default {
  name: 'NavBar',
  mixins: [ThemeStyle],
  props: {
    showBack: {
      type: Boolean,
      default: false
    },
    isRoot: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    isMPA: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  mounted() {
    if (this.isMPA) {
      if (sessionStorage.getItem(firstPageFromNativeKey) === null) {
        sessionStorage.setItem(firstPageFromNativeKey, window.location.href)
      }
    }
  },
  watch: {},
  methods: {
    backClick() {
      if (this.isMPA){
        const ViomiRootView = sessionStorage.getItem(firstPageFromNativeKey)
        if (ViomiRootView === window.location.href) {
          onWebPageBack()
        } else {
          window.history.back()
        }
      } else {
        if (this.isRoot) {
          this.$router.replace({ path: '/', query: this.$route.query })
        } else {
          this.$router.back()
        }
      }
    }
  }
}
</script>
  <style lang="scss" scoped>

  .nav-bar {
    background-color: var(--navBarBackground, #ffffff);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    box-sizing: border-box;
    width: 100%;
    .title {
      font-weight: 500;
      color: var(--textColor, #2C2C2C);
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      max-width: calc(100% - 100px);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .nav-bar-padding{
    padding: 0px 24px;
  }

  .back-icon {
    color: var(--textColor, #2C2C2C) !important;
  }

  </style>
